import React, { useState } from 'react';
import { Layout, Col, Row, Empty, Modal } from 'antd';

import TitleAndNew2 from '../Components/TitleAndNew2/TitleAndNew2';
import DynamicTable from '../Components/DynamicTable/DynamicTable';
import ActivityTab from '../Components/ActivityTab/ActivityTab';
import { useSelector } from 'react-redux';
import NewActivity from '../Components/Forms/NewActivity';

const { Content } = Layout;

const AdminActivities = () => {
  const currentActivity = useSelector((state) => state.currentActivity);
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Layout>
      <Content style={{ margin: '36px' }}>
        <TitleAndNew2
          titleText={'Inne aktywności'}
          buttonText={'Nowa aktywność'}
          action={showModal}
        />
        <Row gutter={16}>
          <Col span={7}>
            <div
              style={{
                background: '#fff',
                padding: '16px',
                borderRadius: '8px',
              }}
            >
              <DynamicTable type={'activities'} userView={true} />
            </div>
          </Col>
          <Col span={17}>
            <div
              style={{
                background: '#fff',
                padding: '16px',
                borderRadius: '8px',
              }}
            >
              {currentActivity.id || currentActivity.newActivity ? (
                <ActivityTab userView={false} />
              ) : (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={<span>Wybierz Aktywność</span>}
                />
              )}
            </div>
          </Col>
        </Row>
      </Content>
      <Modal
        title="Nowa aktywność"
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose={true}
      >
        <NewActivity />
      </Modal>
    </Layout>
  );
};

export default AdminActivities;
